module.exports = __webpack_public_path__ + "img/jumpsuits.c5c3660c.png";